
export const CHECK_TYPES = {
  TO_RECEIVE: "C",
  TO_PAY: "P",
  OWN: "R",
};

export const CHECK_TYPES_VALUES = [
  { label: "A cobrar", value: CHECK_TYPES.TO_RECEIVE },
  { label: "A pagar", value: CHECK_TYPES.TO_PAY },
  { label: "Propio", value: CHECK_TYPES.OWN },
];

export const CHECK_DATE_TYPES_VALUES = [
  { label: "Fecha de ingreso", value: 1 },
  { label: "Fecha de vencimiento", value: 2 },
];
